import React, { useMemo } from "react";

import { ListingBadges as Badges } from "../../components";
import ProductPreviewGallery from "./ProductPreviewGallery";
import "./gallery.css";
import { isMobile } from "react-device-detect";

const PREVIEW_SLIDE_DURATION_MS = 450;

const CarouselGallery = ({
  listing,
  images,
  extraImages = [],
  className = "",
  isProductPreview = false,
  onSlide,
  topRightOverlay,
}) => {
  const galleryImages = useMemo(
    () => [...(images || []), ...(extraImages || [])],
    [images?.map((i) => i.id).join(","), extraImages?.map((i) => i.id).join(",")]
  );

  const thumbnailPosition = isMobile ? "bottom" : "left";

  return (
    <ProductPreviewGallery
      images={galleryImages}
      className={className}
      onSlide={onSlide}
      topRightOverlay={topRightOverlay}
      slideDuration={PREVIEW_SLIDE_DURATION_MS}
      showThumbnails={!isProductPreview && galleryImages.length > 1}
      thumbnailPosition={thumbnailPosition}
      badges={!isProductPreview ? <Badges listing={listing} /> : null}
    />
  );
};

export default CarouselGallery;
